import { TextField } from "./FormBits";
import { money, qty, toNumber } from "@/lib/poshanConstants";
import { CheckCircle2, AlertTriangle } from "lucide-react";

export default function Sidebar({ totals, warnings, schoolInfo, updateSchoolInfo }) {
  return (
    <aside className="space-y-6 lg:sticky lg:top-5 lg:self-start no-print" data-testid="sidebar">
      {/* Quarterly Auto Calc */}
      <section className="rounded-xl border border-border bg-white p-6 shadow-[0_1px_0_rgba(44,53,40,0.04)]" data-testid="quarterly-stats">
        <p className="text-[0.7rem] font-semibold uppercase tracking-[0.28em] text-clay">Step 3</p>
        <h2 className="mt-2 font-heading text-xl font-semibold text-ink-900">Quarterly Auto Calculation</h2>
        <div className="mt-5 space-y-3 text-sm">
          {[
            ["Total Cooking Cost", money(totals.totalCookingCost)],
            ["Ingredient Expenditure", money(totals.totalIngredientExpenditure)],
            ["Rice Consumption", `${qty(totals.totalRiceConsumption)} kg`],
            ["Meals Served", qty(totals.totalMealsServed)],
            ["Cook Payment", money(totals.totalCookPayment)],
            ["Total Cash Outgo", money(totals.totalExpenditure)],
            ["UC Utilized Amount", money(totals.ucUtilizedAmount)],
          ].map(([label, value]) => (
            <div key={label} className="flex items-center justify-between gap-4 border-b border-dashed border-border pb-2">
              <span className="text-ink-700">{label}</span>
              <b className="text-ink-900">{value}</b>
            </div>
          ))}
          <div className="flex items-center justify-between gap-4 pt-1">
            <span className="text-ink-700">Remaining Balance</span>
            <b className="text-clay">{money(totals.remainingBalance)}</b>
          </div>
        </div>
      </section>

      {/* Validation */}
      <section className="rounded-xl border border-border bg-white p-6 shadow-[0_1px_0_rgba(44,53,40,0.04)]" data-testid="validation-panel">
        <h2 className="font-heading text-xl font-semibold text-ink-900">Validation</h2>
        {warnings.length === 0 ? (
          <div className="mt-4 flex items-start gap-3 rounded-lg bg-moss/10 px-4 py-3 text-sm text-moss-dark">
            <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0" />
            <span className="font-medium">No warnings. Reports are ready for printing.</span>
          </div>
        ) : (
          <ul className="mt-4 space-y-2 text-sm">
            {warnings.slice(0, 8).map((w) => (
              <li key={w} className="flex items-start gap-2.5 rounded-lg bg-clay-50 px-3 py-2 text-clay-dark">
                <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0" />
                <span>{w}</span>
              </li>
            ))}
            {warnings.length > 8 && (
              <li className="text-ink-700">{warnings.length - 8} more warnings hidden.</li>
            )}
          </ul>
        )}
      </section>

      {/* OGFR Previous Year */}
      <section className="rounded-xl border border-border bg-white p-6 shadow-[0_1px_0_rgba(44,53,40,0.04)]" data-testid="prev-year-panel">
        <h2 className="font-heading text-xl font-semibold text-ink-900">OGFR Previous Year</h2>
        <p className="mt-1 text-sm text-ink-700">Optional — used in OGFR-23 Table-2.</p>
        <div className="mt-5 space-y-4">
          <TextField testId="prev-sanction-no" label="Previous Sanction No &amp; Date" value={schoolInfo.previousSanctionNoDate} onChange={(v) => updateSchoolInfo("previousSanctionNoDate", v)} />
          <TextField testId="prev-sanctioned-amt" label="Previous Sanctioned Amount" type="number" value={schoolInfo.previousSanctionedAmount} onChange={(v) => updateSchoolInfo("previousSanctionedAmount", toNumber(v))} />
          <TextField testId="prev-unspent-bal" label="Previous Unspent Balance" type="number" value={schoolInfo.previousUnspentBalance} onChange={(v) => updateSchoolInfo("previousUnspentBalance", toNumber(v))} />
          <TextField testId="prev-utilized-amt" label="Previous Utilized Amount" type="number" value={schoolInfo.previousUtilizedAmount} onChange={(v) => updateSchoolInfo("previousUtilizedAmount", toNumber(v))} />
        </div>
      </section>
    </aside>
  );
}
